<mat-form-field appearance="outline" subscriptSizing="dynamic">
  <mat-label>{{ label() }}</mat-label>
  <input
    matInput
    type="number"
    min="1"
    [attr.max]="maxDay"
    [value]="value"
    [disabled]="disabled"
    (input)="onInput($event)"
    (blur)="onBlur()" />
</mat-form-field>

<div class="text-xs">
  <ng-content />
</div>
